import _ from 'lodash'
export const RESET_STATE = 'RESET_STATE'
export const SET_ORDER = 'SET_ORDER'
export const SET_DATA_BS_MYP_05_040 = 'SET_DATA_BS_MYP_05_040'
export const SET_CANCEL_NO = 'SET_CANCEL_NO'


export default {
  [SET_ORDER](state, payload) {
    state.orderDetail = _.cloneDeep(payload)
  },
  [SET_DATA_BS_MYP_05_040](state, order) {
    state.bs_myp_05_040 = order
  },
  [SET_CANCEL_NO](state, data) {
    state.cancelNo = data
  }

}